export function readEmbedded(id) {
  const el = document.getElementById(id);
  return el ? JSON.parse(el.textContent) : null;
}
